import { create } from 'zustand';
import { systemStatusApi, type StatusSummary } from '@/shared/api';

interface SystemStatusStore {
  summary: StatusSummary | null;
  failed: boolean;
  set: (summary: StatusSummary) => void;
  refresh: () => Promise<void>;
}

let inFlight: Promise<void> | null = null;

export const useSystemStatusStore = create<SystemStatusStore>((set) => ({
  summary: null,
  failed: false,
  set: (summary) => set({ summary, failed: false }),
  refresh: () => {
    inFlight ??= systemStatusApi
      .summary()
      .then((res) => set({ summary: res.data ?? null, failed: false }))
      .catch(() => set({ failed: true }))
      .finally(() => {
        inFlight = null;
      });
    return inFlight;
  },
}));
